import React from "react";
import KeyOutlinedIcon from "@mui/icons-material/KeyOutlined";
import SmartphoneOutlinedIcon from "@mui/icons-material/SmartphoneOutlined";
import DevicesIcon from "@mui/icons-material/Devices";
import ProfileCard from "./ProfileCard";

function Row({ icon, title, hint, children }) {
  return (
    <div className="pf-lr">
      <span className="ic">{icon}</span>
      <div>
        <b>{title}</b>
        <small>{hint}</small>
      </div>
      <div className="r">{children}</div>
    </div>
  );
}

export default function SecurityCards({ mfaEnabled, onChangePassword, onToggleMfa, onManageSessions }) {
  return (
    <>
      <ProfileCard id="security" title="Sign-in and security">
        <Row icon={<KeyOutlinedIcon sx={{ fontSize: 18 }} />} title="Password" hint="Use a strong password you don't use elsewhere.">
          <button type="button" className="pf-btn pf-btn-o pf-btn-sm" onClick={onChangePassword}>Change password</button>
        </Row>
        <Row
          icon={<SmartphoneOutlinedIcon sx={{ fontSize: 18 }} />}
          title="Two-step verification"
          hint={mfaEnabled ? "On · Authenticator app" : "Off · Adds a second layer of protection to your account"}
        >
          <span className={`pf-tag ${mfaEnabled ? "ok" : "pe"}`}>{mfaEnabled ? "On" : "Off"}</span>
          <button
            type="button"
            className="pf-sw"
            role="switch"
            aria-checked={mfaEnabled}
            aria-label="Two-step verification"
            onClick={onToggleMfa}
          />
        </Row>
      </ProfileCard>
      <ProfileCard id="sessions" title="Active sessions" subtitle="Devices currently signed in to your account.">
        <Row icon={<DevicesIcon sx={{ fontSize: 18 }} />} title="Signed-in devices" hint="Review where you're signed in and sign out of other devices.">
          <button type="button" className="pf-btn pf-btn-o pf-btn-sm" onClick={onManageSessions}>Manage sessions</button>
        </Row>
      </ProfileCard>
    </>
  );
}
